import Header from '../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../utils/Loader';
import { useGetLearnerProgressQuery,useGetStudentListQuery ,useGetLoadUnitQuery} from "../../Services/api";
import {pageUrl,pageSize} from "../../utils/constants/constants";
export default function LearnerProgress() {
    const [page, setPage] = useState(0);
    const [student_id, setStudent_id] = useState("3");
    const [unit, setUnit] = useState("");
    const [studentName, setStudentName] = useState("");
    
    const {
        data: getLearnerProgress,
        isLoading: isGetLoading,
    } = useGetLearnerProgressQuery({ pageUrl, params:  {student_id,unit,page,pageSize}  });
   
    const { 
        data: StudentList,
        isLoading: loadingStudent    
    } = useGetStudentListQuery();
    const { 
        data: getLoadUnit,
        isLoading: loadingUnit, 
        isError: isGetError,    
    } = useGetLoadUnitQuery({  params:student_id});
      const getPrevious= () => {
        setPage(page-1);
        setStudent_id("");
      }
      const getNext=()=>{
        setPage(page+1);
        setStudent_id("");
      }
      const findStudent=(e)=>{
        setPage(0);
        setStudent_id(e.target.value);
        setStudentName(e.target.selectedOptions[0].getAttribute('data-myattribute'));
      }
      const findCourse=(e)=>{
        setPage(0);
        setUnit(e.target.value);
      }
      if(isGetLoading || loadingUnit) return  <Loader></Loader>
    return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Learner Progress</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Learner Progress</button>
                        </li>
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body table-responsive">
                                                
                                                <div className='row mb-4'>
                                                    <div className='col-lg-2'></div>
                                                    <div className='col-lg-8 bg-dark'>
                                                        <p className='text-center text-white'>Learner Name</p>
                                                       <h2 className='text-center text-white'>
                                                           {studentName}
                                                        </h2>
                                                    </div>
                                                    <div className='col-lg-2'></div>
                                                </div>
                                                <div className='row mb-3'>
                                                    <div className='col-lg-6'>
                                                    <select className="form-control" onChange={findStudent}>
                                                        <option value="">Select Student</option>                                           
                                                        {                            
                                                        StudentList?.data !== 0 ? StudentList?.data?.map((item) => {
                                                            return (
                                                                    <option key={item.student_id} value={item.student_id} data-myattribute={item.first_name+"--"+item.last_name}>
                                                                      {item.first_name} {item.last_name} -- {item.email}
                                                                    </option>                                           
                                                                )
                                                            })
                                                            :
                                                            '<option value="">Select Student</option>'
                                                        }
                                                    </select>
                                                    </div>
                                                    <div className='col-lg-6'>
                                                    <select className="form-control" onChange={findCourse}>
                                                        <option value="">Select Course</option>                                           
                                                        {                            
                                                          getLoadUnit?.data !== 0 ?  getLoadUnit?.data?.map((item) => {
                                                                return (
                                                                    <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                                                    )
                                                            })
                                                            :
                                                            '<option value="">Select Course</option> '

                                                        }
                                                    </select>
                                                    </div>
                                                   
                                                </div>
                       
                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th className='text-capitalize'>Element Name</th>
                                                                <th className='text-capitalize'>Total Time Studied</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            getLearnerProgress?.data?.data_array?.map((item) => {
                                                            return (
                                                                <tr key={item.id}>
                                                                    <td>{item?.learning_outcome?.element_name} </td>
                                                                    <td>{item.element}</td>
                                                                </tr>                                            
                                                                )  
                                                            })  
                                                        } 
                                                        </tbody>
                                                </table>                        
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination">
                                                    {getLearnerProgress?.data?.currentPage !==0 ? <li className="page-item"><button type="button" className="page-link" onClick={getPrevious}>Previous</button></li> :''}
                                                    <li className="page-item"> {getLearnerProgress?.data?.currentPage+1} </li>                                                  
                                                    <li className="page-item"> of {getLearnerProgress?.data?.totalPages}</li>
                                                    {getLearnerProgress?.data?.currentPage !==getLearnerProgress?.data?.totalPages ? <li className="page-item"><button type="button" className="page-link" onClick={getNext}>Next</button></li>:''}
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                        </div>
                    </div>
                </div>
            </div>
            </main>
           
        </div>
    );
}
